import MenuIcon from "@material-ui/icons/Menu";
import { useStyles } from "./AdminStyles";
const AdminHeader = (props) => {
  const classes = useStyles()
  const { handleToggle, currentSelected } = props

  return (
    <div className={classes.adminHeader}>
      <div className={classes.menuBtn} onClick={handleToggle}>
        <MenuIcon />
      </div>
      <div className={classes.adminHeaderContent}>
        <h1 className={classes.adminHeaderTitle}>{currentSelected.title}</h1>
        <p className={classes.adminHeaderSubtitle}>
          {currentSelected.description}
        </p>
      </div>
    </div>
  );
};

export default AdminHeader;
